import { Link } from "@mui/material";
import clsx from "clsx";
import type React from "react";
import { Link as RouterLink } from "react-router-dom";

import { useLinkWithIconStyles } from "./LinkWithIcon.styles";

interface LinkWithIconProps {
    to: string;
    Icon?: JSX.Element;
    className?: string;
    children: React.ReactNode;
}

export const LinkWithIcon: React.FC<LinkWithIconProps> = ({
    to,
    Icon,
    className,
    children,
}): JSX.Element => {
    const classes = useLinkWithIconStyles();

    return (
        <div className={classes.root}>
            <Link
                color="inherit"
                component={RouterLink}
                to={to}
                className={clsx(className, classes.content)}
                sx={{
                    textDecoration: "none",
                    "&:hover": {
                        textDecoration: "underline",
                    },
                }}
            >
                {Icon}
                {children}
            </Link>
        </div>
    );
};
